import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { StaffedRole } from '../../../core/models/staffedRole';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TrackedDialogService } from '../../../core/services/tracked-dialog.service';
import { StaffedRoleService } from '../../../core/services/staffed-role.service';
import { StaffedRoleFormComponent } from './staffed-role-form/staffed-role-form.component';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ConvertCurrencyService } from '../../../core/services/convert-currency.service';
import { CurrencyExchange } from '../../../core/models/currency-exchange ';
import { EmPermissionDirective } from '../../../shared/directives/has-permission.directive';
import { Permission } from '../../../core/enums/permission.enum';
import { forkJoin } from 'rxjs';
import { FileUploadModule } from 'primeng/fileupload';
import { CurrencyExchangeService } from '../../../core/services/currency-exchange.service';
import { TooltipModule } from 'primeng/tooltip';
import { CurrencyOrderService } from '../../../core/services/currency-order.service';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { StaffedRoleRolloverPreview } from '../../../core/models/staffedRoleRollover';
@Component({
  selector: 'em-staffed-role',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, ToastModule, ConfirmDialogModule, DropdownModule, FormsModule, TranslatePipe, EmPermissionDirective, FileUploadModule, TooltipModule, DialogModule, DividerModule],
  templateUrl: './staffed-role.component.html',
  styleUrl: './staffed-role.component.scss',
  providers: [MessageService, ConfirmationService, TrackedDialogService],
})
export class StaffedRoleComponent {
  staffedRoles!: StaffedRole[];
  allStaffedRoles: StaffedRole[] = [];
  roleFilter: string = '';
  //currencyRate!: number;
  selectedFiscalYear: string = 'FY25';
  translations: any = {};
  currencies: string[] = []; // dynamic
  //currencyExchanges: CurrencyExchange[] = [];
  ref: DynamicDialogRef | undefined;
  Permission = Permission;
  isImporting: boolean = false;

  fiscalYearOptions: any[] = [];

  // Rollover properties
  rolloverDialogVisible: boolean = false;
  rolloverSourceFy: string = '';
  rolloverTargetFy: string = '';
  rolloverPreview: StaffedRoleRolloverPreview | null = null;
  rolloverLoading: boolean = false;
  rolloverStep: 'select' | 'preview' | 'done' = 'select';
  rolloverSummary: any = null;

  constructor(
    private staffedRoleService: StaffedRoleService,
    private messageService: MessageService,
    private currencyExchangeService: CurrencyExchangeService,
    private confirmationService: ConfirmationService,
    private dialogService: DialogService,
    private translate: TranslateService,
    private convertCurrencyService: ConvertCurrencyService,
    private currencyOrderService: CurrencyOrderService,
  ) { }

  ngOnInit() {
    
    this.loadTranslations();
    const startFY = 25;
    const endFY = 30;
    this.fiscalYearOptions = Array.from({ length: endFY - startFY + 1 }, (_, i) => {
      const fy = startFY + i;
      return { label: 'FY' + fy, value: 'FY' + fy };
    });
      this.loadActiveCurrenciesAndRoles();
  }
 loadActiveCurrenciesAndRoles() {
    this.currencyExchangeService.getActiveCurrencies().subscribe({
      next: (activeCurrencies) => {
        const activeCurrencyNames: string[] = activeCurrencies
          .map((c: any) => (c.currencyName as string).toUpperCase());
        // Only used to determine column headers/order, no rate calculation here
        this.currencies = this.currencyOrderService.applyOrder(activeCurrencyNames);
        this.getAllStaffedRoles();
      },
      error: (err) => {
        console.error('Error loading currencies:', err);
        this.getAllStaffedRoles();
      }
    });
  }
   /*buildCurrencyExchanges(exchangeRates: CurrencyExchange[]) {
    const latestRates = new Map<string, CurrencyExchange>();

    // Sort by startDate desc so first occurrence per currency = most recent
    const sorted = [...exchangeRates].sort((a, b) =>
      new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
    );

    sorted.forEach(rate => {
      const name = (rate.currencyName as string)?.toUpperCase();
      if (name && !latestRates.has(name)) {
        latestRates.set(name, rate);
      }
    });

    this.currencyExchanges = this.currencies
      .map(c => latestRates.get(c))
      .filter((r): r is CurrencyExchange => !!r);
  }*/
  loadTranslations() {
    this.translate
      .get([
        'layout.configurations.staffedRoles.deleteStaffedRole.detail',
        'layout.configurations.staffedRoles.deleteStaffedRole.title',
        'layout.configurations.staffedRoles.deleteStaffedRole.yes',
        'layout.configurations.staffedRoles.deleteStaffedRole.no',
        'layout.configurations.staffedRoles.deleteStaffedRole.infoMessage.title',
        'layout.configurations.staffedRoles.deleteStaffedRole.infoMessage.detail',
        'layout.configurations.staffedRoles.deleteStaffedRole.successMessage.title',
        'layout.configurations.staffedRoles.deleteStaffedRole.successMessage.detail',
        'layout.configurations.staffedRoles.deleteStaffedRole.successMessage.title',
        'layout.configurations.staffedRoles.addStaffedRole.successMessage.detail',
        'layout.configurations.staffedRoles.addStaffedRole.errorMessage.title',
        'layout.configurations.staffedRoles.editStaffedRole.successMessage.detail',
        'layout.configurations.staffedRoles.editStaffedRole.errorMessage.title',
        'layout.configurations.staffedRoles.deleteStaffedRole.errorMessage.detail',
        'layout.configurations.staffedRoles.addStaffedRole.title',
        'layout.configurations.staffedRoles.addStaffedRole.successMessage.title',
        'layout.configurations.staffedRoles.editStaffedRole.successMessage.title',
        'layout.configurations.staffedRoles.importStaffedRoles.successMessage.title',
        'layout.configurations.staffedRoles.importStaffedRoles.successMessage.detail',
        'layout.configurations.staffedRoles.importStaffedRoles.errorMessage.title',
        'layout.configurations.staffedRoles.importStaffedRoles.errorMessage.detail',
        'layout.configurations.staffedRoles.onlyExcelFilesSupported'
      ])
      .subscribe((translations) => {
        this.translations = translations;
      });
  }


  getAllStaffedRoles() {
    const fiscalYear = this.selectedFiscalYear || undefined;
    this.staffedRoleService.getStaffedRoles(fiscalYear).subscribe({
      next: (data) => {
        // convertedAmount is already computed correctly by the backend for this fiscal year
        this.allStaffedRoles = data;
        if (this.roleFilter && this.roleFilter.trim()) {
          this.applyRoleFilter();
        } else {
          this.staffedRoles = [...this.allStaffedRoles];
        }
      },
      error: (error) => {
        console.error('Error loading staffed roles:', error);
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('common.toast.error'),
          detail: this.translate.instant('layout.configurations.staffedRoles.loadError')
        });
      }
    });
  }
  applyRoleFilter() {
    const term = (this.roleFilter || '').trim().toUpperCase();
    if (!term) {
      this.staffedRoles = [...this.allStaffedRoles];
      return;
    }
    const normalizedTerm = term.replace(/\s+/g, ' - ');
    this.staffedRoles = this.allStaffedRoles.filter(role => {
      const normalizedRole = role.role.toUpperCase()
        .replace(/\s*-\s*/g, ' - ')
        .replace(/^APP-/, '');
      return normalizedRole.includes(normalizedTerm);
    });
  }
  onRoleFilterClick() {
    this.applyRoleFilter();
  }

  clearRoleFilter() {
    this.roleFilter = '';
     this.staffedRoles = [...this.allStaffedRoles];
  }
  /* calculateConvertedAmounts(staffedRole: StaffedRole): StaffedRole {
    const convertedAmount: any = {};

  this.currencyExchanges.forEach(exchange => {
    if (staffedRole.rateEuro != null && exchange.exchangeRate && exchange.exchangeRate > 0) {
      convertedAmount[exchange.currencyName || ''] = {
       convertedAmount: staffedRole.rateEuro / exchange.exchangeRate
      };
    } else {
      convertedAmount[exchange.currencyName || ''] = null;
    }
  });

  return {
    ...staffedRole,
    convertedAmount
  };
}*/
  onFilterChange() {
    this.getAllStaffedRoles();
  }

  onAdd() {
    this.ref = this.dialogService.open(StaffedRoleFormComponent, {
      header: this.translate.instant('layout.configurations.staffedRoles.addStaffedRole.title'),
      width: '500px',
      contentStyle: { overflow: 'auto' },
      data: { currencies: this.currencies },
    });

    this.ref.onClose.subscribe((staffedRole) => {
      if (staffedRole) {
        this.getAllStaffedRoles();
        this.messageService.add({
          severity: 'success',
          summary: this.translations['layout.configurations.staffedRoles.addStaffedRole.successMessage.title'],
          detail: this.translations['layout.configurations.staffedRoles.addStaffedRole.successMessage.detail'],
        });
      }
    });
  }

  onEdit(staffedRole: StaffedRole) {
    this.ref = this.dialogService.open(StaffedRoleFormComponent, {
      header: this.translate.instant('layout.configurations.staffedRoles.editStaffedRole.title'),
      width: '320px',
      contentStyle: { overflow: 'auto' },
      data: { ...staffedRole, currencies: this.currencies },
    });

    this.ref.onClose.subscribe((updatedRole: StaffedRole) => {
      if (updatedRole) {
        const index = this.allStaffedRoles.findIndex(r => r.id === updatedRole.id);
        if (index !== -1) {
          this.allStaffedRoles[index] = updatedRole;
          this.staffedRoles = [...this.allStaffedRoles];
        } else {
          this.getAllStaffedRoles(); // fallback si l'id n'est pas trouvé
        }
        this.messageService.add({
          severity: 'success',
          summary: this.translations['layout.configurations.staffedRoles.editStaffedRole.successMessage.title'],
          detail: this.translations['layout.configurations.staffedRoles.editStaffedRole.successMessage.detail'],
        });
      }
    });
  }

  onDelete(event: Event, id: number) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: this.translate.instant('layout.configurations.staffedRoles.deleteStaffedRole.detail'),
      icon: 'pi pi-info-circle',
      header: this.translate.instant('layout.configurations.staffedRoles.deleteStaffedRole.title'),
      acceptIcon: 'none',
      rejectIcon: 'none',
      acceptLabel: this.translate.instant('layout.configurations.staffedRoles.deleteStaffedRole.yes'),
      rejectLabel: this.translate.instant('layout.configurations.staffedRoles.deleteStaffedRole.no'),
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => {
        this.deleteStaffedRole(id);
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: this.translate.instant('layout.configurations.staffedRoles.deleteStaffedRole.infoMessage.title'),
          detail: this.translate.instant('layout.configurations.staffedRoles.deleteStaffedRole.infoMessage.detail'),
          life: 3000,
        });
      },
    });
  }

  deleteStaffedRole(id: number) {
    this.staffedRoleService.deleteStaffedRole(id).subscribe({
      next: () => {
        this.getAllStaffedRoles();
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('layout.configurations.staffedRoles.deleteStaffedRole.successMessage.title'),
          detail: this.translate.instant('layout.configurations.staffedRoles.deleteStaffedRole.successMessage.detail'),
        });
      },
      error: (error: any) => {
        console.log('Error deleting staffed role: ' + error);
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('layout.configurations.staffedRoles.deleteStaffedRole.errorMessage.title'),
          detail: this.translate.instant('layout.configurations.staffedRoles.deleteStaffedRole.errorMessage.detail'),
        });
      },
    });
  }
  onExport() {
    this.staffedRoleService.exportStaffedRoles(this.selectedFiscalYear || undefined);
  }
  onImport(event: any) {
    const file = event.files[0];

    if (!file) return;

    // Validate file type
    const fileName = file.name.toLowerCase();
    if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('layout.configurations.staffedRoles.importStaffedRoles.errorMessage.title'),
        detail: this.translations['layout.configurations.staffedRoles.onlyExcelFilesSupported']
      });
      return;
    }

    this.isImporting = true;

    this.staffedRoleService.importStaffedRoles(file).subscribe({
      next: (response) => {
        this.isImporting = false;
        this.getAllStaffedRoles(); // Refresh the table
        this.messageService.add({
          severity: 'success',
          summary: this.translations['layout.configurations.staffedRoles.importStaffedRoles.successMessage.title'],
          detail: this.translations['layout.configurations.staffedRoles.importStaffedRoles.successMessage.detail']
        });
        // Clear the file upload
        event.currentFiles = [];
      },
      error: (error) => {
        this.isImporting = false;
        console.error('Error importing staffed roles:', error);
        const errorMessage =
          error.error || error.message || this.translate.instant('layout.configurations.staffedRoles.importStaffedRoles.errorMessage.detail');
        this.messageService.add({
          severity: 'error',
          summary: this.translations['layout.configurations.staffedRoles.importStaffedRoles.errorMessage.title'],
          detail: errorMessage
        });
        // Clear the file upload
        event.currentFiles = [];
      }
    });
  }
  private deepEqual(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) return true;

    if (typeof obj1 !== typeof obj2) return false;
    if (obj1 === null || obj2 === null) return false;

    if (typeof obj1 === 'object') {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);
      if (keys1.length !== keys2.length) return false;

      for (const key of keys1) {
        if (!keys2.includes(key)) return false;
        if (!this.deepEqual(obj1[key], obj2[key])) return false;
      }
      return true;
    }

    return false;
  }

  // Rollover methods
  openRolloverDialog() {
    this.rolloverDialogVisible = true;
    this.rolloverStep = 'select';
    this.rolloverPreview = null;
    this.rolloverSummary = null;
    this.rolloverSourceFy = this.selectedFiscalYear || 'FY25';
    this.rolloverTargetFy = '';
  }

  loadRolloverPreview() {
    if (!this.rolloverSourceFy || !this.rolloverTargetFy) return;
    this.rolloverLoading = true;
    this.staffedRoleService.previewRollover(this.rolloverSourceFy, this.rolloverTargetFy).subscribe({
      next: (preview) => {
        this.rolloverPreview = preview;
        this.rolloverStep = 'preview';
        this.rolloverLoading = false;
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('layout.configurations.staffedRoles.rollover.errorTitle'),
          detail: err.error?.message || err.message || this.translate.instant('layout.configurations.staffedRoles.rollover.previewError')
        });
        this.rolloverLoading = false;
      }
    });
  }

  executeRollover() {
    this.rolloverLoading = true;
    this.staffedRoleService.executeRollover(this.rolloverSourceFy, this.rolloverTargetFy).subscribe({
      next: (summary) => {
        this.rolloverLoading = false;
        this.closeRolloverDialog();
        this.getAllStaffedRoles();
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('layout.configurations.staffedRoles.rollover.successTitle'),
          detail: this.translate.instant('layout.configurations.staffedRoles.rollover.successDetail')
        });
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('layout.configurations.staffedRoles.rollover.errorTitle'),
          detail: err.error?.message || err.message || this.translate.instant('layout.configurations.staffedRoles.rollover.executeError')
        });
        this.rolloverLoading = false;
      }
    });
  }

  closeRolloverDialog() {
    this.rolloverDialogVisible = false;
    this.rolloverPreview = null;
    this.rolloverSummary = null;
    this.rolloverStep = 'select';
  }
}